export default "__VITE_PUBLIC_ASSET__493fcff7__"